/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';

import { IEventTicket } from '@/@types/events';
import PreSale from '@/components/Widget/pre-sale';
import Tickets from '@/components/Widget/tickets';
import { api } from '@/services/api';
import { SeatingChart } from '@seatsio/seatsio-react';

import * as S from './styles';

type Props = {
  type?: 'passive' | 'active' | 'semi-active';
  eventId: number;
  eventHaveSeats?: boolean;
  className?: string;
  termChecked?: boolean;
  token?: string;
  selectedMapSeats?: { codItem: number; objectId: string }[] | null;
  seatingChart?: SeatingChart;
};

type Event = {
  codEvento: number;
  prevendaEvento: 'SIM' | 'NAO';
};

const Widget = ({
  type = 'active',
  eventId,
  className,
  termChecked = false,
  token,
  selectedMapSeats,
  seatingChart,
  eventHaveSeats,
}: Props) => {
  const [event, setEvent] = useState<Event>(null);
  const [tickets, setTickets] = useState<IEventTicket[]>([]);
  const [loadingTickets, setLoadingTickets] = useState(true);
  const [mapTickets, setMapTickets] = useState<IEventTicket[]>([]);
  const [selectedMapTickets, setSelectedMapTickets] = useState<
    { ticket: IEventTicket; objectId: string }[]
  >([]);
  const [allTickets, setAllTickets] = useState<IEventTicket[]>([]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingTickets(true);

        const url = `/v1/web/events/${eventId}/tickets-available${
          token ? `?cToken=${token}` : ``
        }`;
        const response = await api.get(url);

        const ticketsList: IEventTicket[] | undefined = response.data.tickets;

        const filteredListTickets = ticketsList
          ? ticketsList.filter(
              (ticket: IEventTicket) =>
                ticket.CATEGORIA_SEATIO_SETOR.length <= 0 &&
                ticket.RELACIONADOS_ITEM.length <= 0,
            )
          : [];
        const filteredMapTickets = ticketsList
          ? ticketsList.filter(
              (ticket: IEventTicket) =>
                ticket.CATEGORIA_SEATIO_SETOR.length > 0 &&
                ticket.RELACIONADOS_ITEM.length <= 0,
            )
          : [];

        setEvent(response.data.event);
        setTickets(filteredListTickets);
        setMapTickets(filteredMapTickets);
        setAllTickets(ticketsList);
      } catch (err) {
        if (err) {
          const message = err?.response?.data?.error?.message;
          if (message) {
            return console.log(message);
          }
          return console.log('Error without message');
        }

        return console.log('Undentified error');
      } finally {
        setLoadingTickets(false);
      }
    })();
  }, [eventId]);

  useEffect(() => {
    if (selectedMapSeats) {
      const filteredMapTickets = mapTickets.reduce((prev, curr) => {
        const seatQuantity = selectedMapSeats.filter(
          item => curr.id === item.codItem,
        ).length;

        if (seatQuantity > 0) {
          Array.from(Array(seatQuantity).keys()).forEach(() => {
            prev.push(curr);
          });
        }
        return prev;
      }, []);

      const mappedSelectedMapTickets = filteredMapTickets.map(item => ({
        ticket: item,
        objectId:
          selectedMapSeats.find(value => value.codItem === item.id)?.objectId ??
          '',
      }));
      setSelectedMapTickets(mappedSelectedMapTickets);
    }
  }, [selectedMapSeats]);

  return (
    <S.Wrapper className={className}>
      {loadingTickets && <S.Empty>Aguarde...</S.Empty>}

      {!loadingTickets &&
        tickets.length <= 0 &&
        event?.prevendaEvento === 'NAO' &&
        !eventHaveSeats && (
          <S.Empty>Não existem ingressos disponíveis.</S.Empty>
        )}

      {((tickets.length > 0 && event?.prevendaEvento === 'NAO') ||
        !!eventHaveSeats) && (
        <Tickets
          type={type}
          tickets={tickets}
          termChecked={termChecked}
          eventId={eventId}
          token={token}
          selectedSeatsMapTickets={selectedMapTickets}
          seatingChart={seatingChart}
          allTickets={allTickets}
        />
      )}

      {event?.prevendaEvento === 'SIM' && <PreSale eventId={eventId} />}
    </S.Wrapper>
  );
};

export default React.memo(Widget);
